import React from 'react';
import { Link } from 'react-router-dom';
import { formatTimestamp, getCameraDisplayName } from '../utils/dateUtils';

const BellIcon = ({ size = 24, className = "" }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8a6 6 0 0 0-6-6v-1a1 1 0 0 0-2 0v1a6 6 0 0 0-6 6v3c0 2.22 1.21 4.3 3.42 5.37L10 21h4c2.21-1.07 3.42-3.15 3.42-5.37V8z" />
    <path d="M9 21v-1a3 3 0 0 1 6 0v1" />
  </svg>
);

const XIcon = ({ size = 16, className = "" }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const AlertList = ({ alerts, connectionState = 'disconnected', isConnected = false, onDeleteAlert = null }) => (
  <div className="bg-gray-800 rounded-xl shadow-xl p-6 border border-gray-700">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-2xl font-semibold text-white flex items-center">
        <BellIcon className="mr-2 text-red-400" /> Recent Alerts
      </h3>
      <div className="flex items-center space-x-3">
        {/* WebSocket Connection Status */}
        <div className="flex items-center space-x-2">
          <div className={`w-2 h-2 rounded-full ${
            isConnected ? 'bg-green-400' : 
            connectionState === 'connecting' ? 'bg-yellow-400' : 
            'bg-red-400'
          }`}></div>
          <span className="text-xs text-gray-400">
            {isConnected ? 'Live' : 
             connectionState === 'connecting' ? 'Connecting...' : 
             'Offline'}
          </span>
        </div>
        {alerts.length > 0 && (
          <Link 
            to="/alerts" 
            className="text-sm text-blue-400 hover:text-blue-300 transition-colors duration-200"
          >
            View All →
          </Link>
        )}
      </div>
    </div>
    <div className="space-y-4 max-h-80 overflow-y-auto pr-2">
      {alerts.length > 0 ? (
        alerts.map(alert => (
          <div key={alert.id} className="bg-red-900 bg-opacity-30 border-l-4 border-red-500 p-4 rounded-lg">
            <div className="flex items-start justify-between">
              <div className="flex-1 pr-3">
                <div className="flex items-center space-x-2 mb-1">
                  <p className="font-bold text-sm text-gray-300">
                    {formatTimestamp(alert.timestamp)}
                  </p>
                  {alert.status && (
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      alert.status === 'detected' 
                        ? 'bg-yellow-600 text-yellow-100' 
                        : alert.status === 'processed'
                        ? 'bg-green-600 text-green-100'
                        : 'bg-gray-600 text-gray-100'
                    }`}>
                      {alert.status === 'detected' ? 'DETECTED' : 
                       alert.status === 'processed' ? 'PROCESSED' : 
                       'UNKNOWN'}
                    </span>
                  )}
                </div>
                <p className="text-sm text-gray-400">Camera: {getCameraDisplayName(alert)}</p>
                <p className="text-sm text-gray-400 mt-1">{alert.ai_description || alert.ai_response}</p>
              </div>
              {onDeleteAlert && (
                <button
                  onClick={() => onDeleteAlert(alert.id)}
                  className="flex-shrink-0 p-2 text-gray-400 hover:text-red-400 hover:bg-red-900 hover:bg-opacity-30 rounded-lg transition-colors duration-200 ml-2"
                  title="Delete alert"
                >
                  <XIcon size={18} />
                </button>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-8">
          <BellIcon className="mx-auto text-gray-500 mb-2" size={48} />
          <p className="text-gray-500 text-sm">No recent alerts</p>
          <p className="text-gray-600 text-xs mt-1">Alerts will appear here when AI detects suspicious activity</p>
        </div>
      )}
    </div>
  </div>
);

export default AlertList;